<template>
  <li class="list__item">
    <div class="declaration">
      <div class="num-decl-cover">
        <span class="declaration__num">
          <router-link :to="{ name: 'RouterDTPage', params: { nd: nd } }">
            {{ regnum }}
          </router-link>
        </span>
        <a
          v-if="this.pdf"
          class="dt-num-pdf-link declaration__out-mob"
          accept="application/pdf"
          target="_blank"
          :href="`/outside/show_pdf?path=${regnum?.replaceAll('/', '_')}`"
        >
          <img
            src="@/assets/img/icons/pdf_dt.svg"
            alt="скачать pdf декларации"
          />
        </a>
        <a
          href="javascript:void(0);"
          class="declaration__out-mob"
          @click="$emit('showHistory')"
          ><img
            class="link-journal-img"
            src="@/assets/img/icons/link-out.svg"
            alt=""
            width="32"
            height="32"
          />
        </a>
      </div>
      <div class="declaration__declarant">
        <span class="declarant__name">{{ declarant }}</span>
      </div>
      <StatusComponent
        :clmod="'status__list'"
        :statused="statused"
        :solutioncode="solutioncode"
        :lmdate="lastmsgdate"
      />
      <div class="type type__list">
        <div class="type__main">{{ edproc }}</div>
        <span class="code-short"> Код | {{ solutioncode }}</span>
      </div>
      <p
        class="declaration__txt"
        :class="`${this.fullStatus ? 'declaration__txt--opened' : ''}`"
        @click="this.fullStatus = !this.fullStatus"
      >
        {{ dopstatused }}
      </p>
      <div class="declaration__out">
        <a
          v-if="this.pdf"
          class="dt-num-pdf-link"
          target="_blank"
          :href="`/outside/show_pdf?path=${regnum?.replaceAll('/', '_')}`"
        >
          <img
            src="@/assets/img/icons/pdf_dt.svg"
            alt="скачать pdf декларации"
          />
        </a>
      </div>

      <a
        href="javascript:void(0);"
        class="declaration__out"
        @click="$emit('showHistory')"
        ><img
          class="link-journal-img"
          src="@/assets/img/icons/link-out.svg"
          alt=""
          width="32"
          height="32"
        />
      </a>
    </div>
  </li>
</template>

<script>
import StatusComponent from "@/components/Status";

export default {
  name: "ListDTRow",
  data: () => ({
    fullStatus: false,
  }),
  components: {
    StatusComponent,
  },
  props: {
    nd: {
      type: String,
      required: true,
    },
    declarant: {
      type: String,
      default: "--",
    },
    regnum: {
      type: String,
      default: "Б/Н",
    },
    statused: {
      type: String,
      default: "Отсутствует",
    },
    lastmsgdate: {
      type: String,
      default: "--",
    },
    edproc: {
      type: String,
      default: "",
    },
    dopstatused: {
      type: String,
      default: "",
    },
    solutioncode: {
      type: String,
      default: "0",
    },
    pdf: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["showHistory"],
};
</script>
